import React from "react";
import "./Incrementer.css";
import { useSelector } from "react-redux";
import { fireGtmEvent } from "../../utils/googleAnalytics";

const Incrementer = ({ value, setValue, addonName }) => {
  const {
    hotelData: { name },
  } = useSelector((state) => state.hotelInfo);
  const increment = () => {
    setValue((val) => val + 1);
    fireGtmEvent(`guest_count_incremented`, { name: addonName, value: value + 1 });
  };
  const decrement = () => {
    if (addonName === "Adult" && value === 1) {
      return;
    }
    value > 0 && setValue((val) => val - 1);
    fireGtmEvent(`guest_count_decremented`, { name: addonName, value: value - 1});
  };

  return (
    <div className="incrementer">
      <div onClick={decrement} className="decrement">
        -
      </div>
      <div className="incrementer__value">{value}</div>

      <div onClick={increment} className="increment">
        +
      </div>
    </div>
  );
};

export default Incrementer;
